import React from "react";
import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

interface Dam {
  name: string;
  position: [number, number];
}

const dams: Dam[] = [
  { name: "Insiza Dam", position: [-20.33166, 29.25494] },
  { name: "Inyankuni Dam", position: [-20.34284, 29.11529] },
  { name: "Lower Ncema Dam", position: [-20.33861, 28.99722] },
  { name: "Umzingwane Dam", position: [-20.3892, 28.971] },
  { name: "Upper Ncema Dam", position: [-20.27408, 28.9759] },
  { name: "Mtshabezi Dam", position: [-20.57016, 28.84033] }
];

const MapView: React.FC = () => {
  return (
    <MapContainer
      center={[-20.34, 29.0] as [number, number]}
      zoom={9}
      style={{ minHeight: "100vh", width: "100%" , zIndex: 0, position: 'relative'}}
    >
      <TileLayer
        attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {dams.map((dam, idx) => (
        <Marker key={idx} position={dam.position}>
          <Tooltip permanent direction="top" offset={[0, -10]}>
            <strong>{dam.name}</strong>
          </Tooltip>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default MapView;
